// ============================================================================
// 2-SAT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: '2-sat',
  name: '2-SAT',
  category: 'SAT',
  complexity: {
    time: 'O(N + M)',
    space: 'O(N + M)'
  },
  description: 'A problem of determining whether a Boolean formula in 2-CNF (conjunctive normal form with at most 2 literals per clause) is satisfiable. Solved by constructing an implication graph and finding strongly connected components.'
};
